/**
 * @generated SignedSource<<03fd7dd3e9043d5b05d994390be41bd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberOnboardingCustomProfileFieldQuestion_OrganizationFragment$data = {
  readonly id: string;
  readonly isMemberOnboardingRequired: boolean;
  readonly " $fragmentType": "MemberOnboardingCustomProfileFieldQuestion_OrganizationFragment";
};
export type MemberOnboardingCustomProfileFieldQuestion_OrganizationFragment$key = {
  readonly " $data"?: MemberOnboardingCustomProfileFieldQuestion_OrganizationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberOnboardingCustomProfileFieldQuestion_OrganizationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberOnboardingCustomProfileFieldQuestion_OrganizationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMemberOnboardingRequired",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "b0fa0187922b7af21652f32425d15947";

export default node;
